"use strict";

// ---------------------------------------------------
// Dependencies

var FieldValidation = require('bunsen/validation/deprecated/field-validations/FieldValidation');
var RegexRule = require('bunsen/validation/deprecated/rules/RegexRule');
var _ = require('underscore');

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Module Definition and Instance Properties

/**
 * @class RegexFieldValidation
 * @extends FieldValidation
 */
var RegexFieldValidation = module.exports = FieldValidation.extend({
    autoRun: true,
    initialize: function (options) {
        options = options || {};
        this.regex = options.regex || this.regex;
        this.message = options.message || this.message;
        this.noMatch = _.isBoolean(options.noMatch) ? options.noMatch : this.noMatch;
        this.rule = this.createRule();
        RegexFieldValidation.__super__.initialize.call(this, options);
    },
    createRule: function () {
        return new RegexRule(_.pick(this, 'regex', 'noMatch', 'message'));
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/validation/deprecated/field-validations/RegexFieldValidation.js
// module id = 119
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54